import {
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { MoneyFormatv2, MoneyFormatv3 } from '../../library/MoneyFormat';
import NewFyButtons from './FYCreationButton';
import { useDispatch, useSelector } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';
import { createBalanceSheetDashboardData, createPandLDashboardData } from '../../graphql/mutations';
import moment from 'moment';
import { genericUpdate, updateEntityDetails } from '../../redux/reducers/FYSetupStep';
import { fetchBalanceSheetData, fetchProfitNLossData } from '../../redux/reducers/DashboardSlice';
import { showErrorSnackbar } from '../snackBar/snakbar';
import { useThemes } from '../Theme/theme';
import { useFetchDashboardDataQuery } from '../../redux/apis/dashboardApi';
import { useVirtualizer } from '@tanstack/react-virtual';
import { CancelPresentation, NotInterested } from '@mui/icons-material';

function FYSterpThree() {
  const { theme } = useThemes();

  const headerStyle = {
    backgroundColor: theme.palette.background.tablebg,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '5px 0',
  };

  const cellStyle = {
    padding: '0px 5px',
    wordBreak: 'break-word',
  };

  const checkboxCellStyle = {
    width: '4%',
    minWidth: '35px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const rowContainerStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '5px 0',
    minHeight: '35px',
  };

  const colFlex = (flex) => ({
    flex: `${flex} 1 0`,
    minWidth: flex === 2 ? '120px' : '160px',
    padding: '0px 5px',
    display: 'flex',
    justifyContent: flex === 2 ? 'flex-end' : 'flex-start',
  });

  const createNewFyDta = useSelector((state) => state?.newFyStepsReducer);

  const [balanceSheetAccounts, setBalanceSheetAccounts] = useState([]);
  const [profitNLoss, setProfitNLosssAccounts] = useState([]);
  const [BsSelectedRows, setBsSelectedRows] = useState([]);
  const [PLSelectedRows, setPLSelectedRows] = useState([]);
  const [turnover, setTurnover] = useState(0);

  const dispatch = useDispatch();

  const { data: dashboardata, isLoading } = useFetchDashboardDataQuery(
    {
      startdate: createNewFyDta?.currentFYDta?.startdate,
      enddate: createNewFyDta?.currentFYDta?.enddate,
      openingbalance: 1,
      companyid: createNewFyDta?.currentFYDta?.companyid,
      financialyearid: createNewFyDta?.currentFYDta?.financialyearid,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    getBalanceSheetAndProfitNLossFn();
  }, [dashboardata]);

  async function getBalanceSheetAndProfitNLossFn() {
    try {
      dispatch(genericUpdate({ key: 'backdropOpen', value: true }));
      const BSFilterDta = dashboardata.filter((item) => {
        return item.accounttypecd === 'BS' && item.accountid !== 12 && item.accountid !== 25;
      });

      const PnLFilterDta = dashboardata.filter((item) => {
        return item.accounttypecd === 'PandL';
      });
      setPLSelectedRows(PnLFilterDta.map((row) => row.accountid));
      setBsSelectedRows(BSFilterDta.map((row) => row.accountid));
      setBalanceSheetAccounts(BSFilterDta);
      setProfitNLosssAccounts(PnLFilterDta);
      dispatch(genericUpdate({ key: 'backdropOpen', value: false }));
    } catch (error) {
      console.log(error);
      dispatch(genericUpdate({ key: 'backdropOpen', value: false }));
    }
  }

  const handleCheckboxChange = (e, row, name) => {
    if (e.target.checked) {
      if (name === 'BS') setBsSelectedRows((preArray) => [...preArray, row.accountid]);
      if (name === 'PL') setPLSelectedRows((preArray) => [...preArray, row.accountid]);

      const idsListL = createNewFyDta.AccountIds.split(',');
      const removeAsId = idsListL.filter((id) => id !== row.accountid.toString());

      dispatch(genericUpdate({ key: 'AccountIds', value: removeAsId.join(',') }));
    } else {
      if (name === 'BS') {
        const arrayOfElements = BsSelectedRows.filter((element) => element !== row.accountid);
        setBsSelectedRows(arrayOfElements);
      }
      if (name === 'PL') {
        const arrayOfElements = PLSelectedRows.filter((element) => element !== row.accountid);
        setPLSelectedRows(arrayOfElements);
      }

      if (createNewFyDta.AccountIds !== '' && createNewFyDta.AccountIds !== undefined) {
        const idsList = createNewFyDta.AccountIds.split(',');
        idsList.push(row.accountid.toString());
        const updatedAccountIdsString = idsList.join(',');
        dispatch(genericUpdate({ key: 'AccountIds', value: updatedAccountIdsString }));
      } else {
        dispatch(genericUpdate({ key: 'AccountIds', value: row.accountid.toString() }));
      }
    }
  };

  const handleonSelectAllClick = (e, typecd) => {
    if (typecd === 'Bs') {
      if (e.target.checked) {
        setBsSelectedRows(balanceSheetAccounts.map((row) => row.accountid));
        dispatch(
          genericUpdate({
            key: 'AccountIds',
            value: '',
          })
        );
      } else {
        setBsSelectedRows(balanceSheetAccounts.filter((row) => row.restrictedflag === 1).map((row) => row.accountid));
        const includeBalanceAccounts = balanceSheetAccounts.filter((account) => account.restrictedflag === 0).map((row) => row.accountid);
        dispatch(
          genericUpdate({
            key: 'AccountIds',
            value: includeBalanceAccounts.join(','),
          })
        );
      }
    }

    if (typecd === 'pandl') {
      if (e.target.checked) {
        setPLSelectedRows(profitNLoss.map((row) => row.accountid));
        const createdAccountsID = profitNLoss.filter((row) => row.restrictedflag === 0).map((row) => row.accountid);
        dispatch(
          genericUpdate({
            key: 'AccountIds',
            value: createdAccountsID.join(','),
          })
        );
      } else {
        setPLSelectedRows(profitNLoss.filter((row) => row.restrictedflag === 1).map((row) => row.accountid));
      }
    }
  };

  const [closingBalanceManuallyUnchecked, setClosingBalanceManuallyUnchecked] = useState({
    partyTransfer: false,
    ledgerTransfer: false,
  });

  const handleCheckBox = (e) => {
    const { id, name, checked } = e.target;
    const value = checked ? 1 : 0;
    const entity = createNewFyDta?.[name];

    dispatch(
      updateEntityDetails({
        part: name,
        key: id,
        value,
      })
    );

    if (id === 'closingBalance' && !checked) {
      setClosingBalanceManuallyUnchecked((prev) => ({
        ...prev,
        [name]: true,
      }));
      return;
    }

    if (!checked && id === 'active' && entity?.inactive === 0) {
      dispatch(
        updateEntityDetails({
          part: name,
          key: 'closingBalance',
          value: 0,
        })
      );
      setClosingBalanceManuallyUnchecked((prev) => ({
        ...prev,
        [name]: false,
      }));
    }

    if (!checked && id === 'inactive' && entity?.active === 0) {
      dispatch(
        updateEntityDetails({
          part: name,
          key: 'closingBalance',
          value: 0,
        })
      );
      setClosingBalanceManuallyUnchecked((prev) => ({
        ...prev,
        [name]: false,
      }));
    }

    if (checked && entity?.closingBalance === 0 && (id === 'active' || id === 'inactive') && !closingBalanceManuallyUnchecked[name]) {
      dispatch(
        updateEntityDetails({
          part: name,
          key: 'closingBalance',
          value: 1,
        })
      );
    }
  };

  const isNextFY = parseInt(createNewFyDta.currentFYDta?.startyear) + 1 === parseInt(createNewFyDta.newFYDta?.startyear);

  // Ledger checks
  const isLedgerTransferEmpty = createNewFyDta?.ledgerTransfer?.inactive === 0 && createNewFyDta?.ledgerTransfer?.active === 0;

  const isLedgerDisabled = !isNextFY || isLedgerTransferEmpty;

  let ledgerTooltipMessage = '';
  if (!isNextFY) {
    ledgerTooltipMessage = 'You can transfer balance only to the immediate next Financial Year.';
  } else if (isLedgerTransferEmpty) {
    ledgerTooltipMessage = 'Please select either Active or Inactive ledgers to enable Closing Balance transfer.';
  } else {
    ledgerTooltipMessage =
      'Select this option to carry forward ledger closing balance to the next financial year (party ledgers will remain unaffected).';
  }

  // Party checks
  const isPartyTransferEmpty = createNewFyDta?.partyTransfer?.inactive === 0 && createNewFyDta?.partyTransfer?.active === 0;

  const isPartyDisabled = !isNextFY || isPartyTransferEmpty;

  let partyTooltipMessage = '';
  if (!isNextFY) {
    dispatch(
      updateEntityDetails({
        part: 'ledgerTransfer',
        key: 'closingBalance',
        value: 0,
      })
    );
    dispatch(
      updateEntityDetails({
        part: 'partyTransfer',
        key: 'closingBalance',
        value: 0,
      })
    );
    partyTooltipMessage = 'You can transfer balance only to the immediate next Financial Year.';
  } else if (isPartyTransferEmpty) {
    partyTooltipMessage = 'Please select either Active or Inactive parties to enable Closing Balance transfer.';
  } else {
    partyTooltipMessage = 'Check this to transfer only the closing balance to the next Financial Year';
  }

  const table1ref = useRef(null);
  const table2ref = useRef(null);

  const rowBsVirtualizer = useVirtualizer({
    count: balanceSheetAccounts.length,
    getScrollElement: () => table1ref.current,
    estimateSize: () => 40,
  });

  const rowPandLVirtualizer = useVirtualizer({
    count: profitNLoss.length,
    getScrollElement: () => table2ref.current,
    estimateSize: () => 40,
  });

  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box
        sx={{
          paddingLeft: { lg: '71px' },
          paddingBottom: { lg: '20px' },
          paddingRight: { lg: '32px' },
          marginTop: { sm: 2, lg: 4 },
        }}
      >
        <Typography variant="body2" sx={{ fontSize: '24px', fontWeight: 'bold', marginBottom: 1 }}>
          Transfer Groups,Ledgers & Closing Balances{' '}
          <span>
            {createNewFyDta?.newFYDta?.startyear && createNewFyDta?.newFYDta?.endyear
              ? `(${createNewFyDta.newFYDta.startyear} - ${createNewFyDta.newFYDta.endyear})`
              : ''}
          </span>{' '}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', padding: 1, gap: 2 }}>
          <FormControl>
            <FormLabel
              id="demo-row-radio-buttons-group-label"
              sx={{
                color: theme?.palette?.TmId.id.toString().includes('9') ? '#ffffff' : 'black',
              }}
            >
              Would you like to transfer Groups and Ledgers to the new financial Year (FY)?
            </FormLabel>
            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
              <FormControlLabel
                value=""
                onClick={() => dispatch(genericUpdate({ key: 'GroupLedger', value: 1 }))}
                control={<Radio checked={createNewFyDta.GroupLedger === 1} />}
                label="Yes"
              />
              <FormControlLabel
                value="No"
                onClick={() => dispatch(genericUpdate({ key: 'GroupLedger', value: 0 }))}
                control={<Radio checked={createNewFyDta.GroupLedger === 0} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>
          {createNewFyDta.GroupLedger === 1 && (
            <>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="h1" sx={{ width: '80px' }}>
                  Ledgers:
                </Typography>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="active"
                        name="ledgerTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.ledgerTransfer?.active === 1}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="inactive"
                        name="ledgerTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.ledgerTransfer?.inactive === 1}
                      />
                    }
                    label="Inactive"
                  />
                  <Tooltip title={ledgerTooltipMessage} placement="top" arrow>
                    <Box component="span" display="inline-flex">
                      <FormControlLabel
                        control={
                          <Checkbox
                            id="closingBalance"
                            name="ledgerTransfer"
                            onChange={handleCheckBox}
                            disabled={isLedgerDisabled}
                            checked={createNewFyDta?.ledgerTransfer?.closingBalance === 1}
                          />
                        }
                        label="Closing balance"
                      />
                    </Box>
                  </Tooltip>
                </FormGroup>
              </Box>

              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="h1" sx={{ width: '80px' }}>
                  Parties:
                </Typography>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="active"
                        name="partyTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.partyTransfer?.active === 1}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="inactive"
                        name="partyTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.partyTransfer?.inactive === 1}
                      />
                    }
                    label="Inactive"
                  />

                  <Tooltip title={partyTooltipMessage}>
                    <span>
                      {' '}
                      <FormControlLabel
                        control={
                          <Checkbox
                            id="closingBalance"
                            name="partyTransfer"
                            onChange={handleCheckBox}
                            disabled={isPartyDisabled}
                            checked={createNewFyDta?.partyTransfer?.closingBalance === 1}
                          />
                        }
                        label="Closing balance"
                      />
                    </span>
                  </Tooltip>
                </FormGroup>
              </Box>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography variant="h1" sx={{ width: '80px' }}>
                  Items:
                </Typography>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="active"
                        name="itemTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.itemTransfer?.active === 1}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="inactive"
                        name="itemTransfer"
                        onChange={handleCheckBox}
                        checked={createNewFyDta?.itemTransfer?.inactive === 1}
                      />
                    }
                    label="Inactive"
                  />
                </FormGroup>
              </Box>

              {isNextFY && (createNewFyDta.ledgerTransfer?.closingBalance === 1 || createNewFyDta.partyTransfer?.closingBalance === 1) && (
                <>
                  <Box
                    sx={{
                      marginTop: 1,
                      border: '1px dotted #000',
                      padding: 2,
                      position: 'relative',
                    }}
                  >
                    <Typography variant="body2" sx={{ fontSize: '14px', fontFamily: 'inherit' }}>
                      <span style={{ fontWeight: 'semi-bold', fontSize: '14px', fontFamily: 'inherit' }}>Note:</span> Once the transfer is confirmed, the closing balance Accounts
                      will be transferred as Opening Balance to above-mentioned financial year. Any changes made to the current financial
                      year afterwards will not be automatically carried forward.
                    </Typography>
                  </Box>
                </>
              )}
              <Box sx={{ marginTop: 1 }}>
                <Typography variant="body2" sx={{ fontSize: '17px', fontWeight: 'bold' }}>
                  {createNewFyDta.newFY}
                </Typography>
              </Box>
              <Box
                sx={{
                  border: '1px dotted #000',
                  padding: 2,
                  position: 'relative',
                }}
              >
                <Typography variant="body2" sx={{ fontSize: '14px', fontFamily: 'inherit' }}>
                  <span style={{ fontWeight: '600', fontSize: '14px', fontFamily: 'inherit' }}>Note:</span> By default, Active
                  {createNewFyDta.ledgerTransfer?.closingBalance === 1 ||
                    (createNewFyDta.partyTransfer?.closingBalance === 1 && ' and Closing Balance')}{' '}
                  are selected. You can modify the selections above as per your requirement.
                </Typography>
              </Box>
            </>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            marginTop: 1,
          }}
        >
          {createNewFyDta.GroupLedger === 1 && (
            <>
              <Box
                sx={{
                  backgroundColor: theme.palette.secondary.main,
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '16px',
                }}
              >
                <Typography variant="body2" sx={{ color: 'white' }}>
                  Balance Sheet Accounts
                </Typography>
              </Box>
              <div style={{ boxSizing: 'border-box', width: '100%' }}>
                {/* Header */}
                <div style={headerStyle}>
                  <div style={checkboxCellStyle}>
                    <Checkbox
                      color="primary"
                      indeterminate={BsSelectedRows.length > 0 && BsSelectedRows.length < balanceSheetAccounts.length}
                      checked={balanceSheetAccounts.length > 0 && BsSelectedRows.length === balanceSheetAccounts.length}
                      onChange={(e) => handleonSelectAllClick(e, 'Bs')}
                      inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                  </div>
                  <div style={colFlex(4)}>
                    <Typography variant="body1" fontWeight="bold">
                      Accounts
                    </Typography>
                  </div>
                  <div style={colFlex(4)}>
                    <Typography variant="body1" fontWeight="bold">
                      Groups
                    </Typography>
                  </div>
                  <div style={colFlex(2)}>
                    <Typography variant="body1" fontWeight="bold">
                      Closing Balance
                    </Typography>
                  </div>
                </div>

                {/* Virtualized Scrollable Content */}
                <div
                  ref={table1ref}
                  style={{
                    height: '400px',
                    overflowY: 'auto',
                    border: '1px solid #ccc',
                  }}
                >
                  <div
                    style={{
                      height: `${rowBsVirtualizer.getTotalSize()}px`,
                      position: 'relative',
                    }}
                  >
                    {rowBsVirtualizer.getVirtualItems().map((virtualRow) => {
                      const row = balanceSheetAccounts[virtualRow.index];
                      const isDefaultRow = row?.accountid === 26 && row?.immediate_parent_group_id === 3;
                      const pathParts = row?.group_path?.split('/') || [];
                      const isPartyLedger = pathParts.includes('7') || pathParts.includes('15');
                      const hasBalance = isPartyLedger
                        ? createNewFyDta?.partyTransfer?.closingBalance !== 0
                        : createNewFyDta?.ledgerTransfer?.closingBalance !== 0;
                      const displayBalance = hasBalance ? Math.abs(row?.balance) : 0;
                      const balanceLabel =
                        row?.balance !== 0
                          ? row?.balancesign === 1
                            ? row?.balance > 0
                              ? 'Cr'
                              : 'Dr'
                            : row?.balancesign === -1
                            ? row?.balance > 0
                              ? 'Dr'
                              : 'Cr'
                            : null
                          : null;

                      const isActive = isPartyLedger
                        ? createNewFyDta?.partyTransfer?.active === 1
                        : createNewFyDta?.ledgerTransfer?.active === 1;

                      const isInActive = isPartyLedger
                        ? createNewFyDta?.partyTransfer?.inactive === 1
                        : createNewFyDta?.ledgerTransfer?.inactive === 1;

                      const tooltipItem = isPartyLedger ? 'Parties' : 'Ledgers';

                      return (
                        <div
                          key={virtualRow.key}
                          ref={virtualRow.measureRef}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: `${virtualRow.size}px`,
                            borderBottom: '1px solid rgb(218, 217, 217)',
                            transform: `translateY(${virtualRow.start}px)`,
                          }}
                        >
                          <div style={rowContainerStyle}>
                            <div style={checkboxCellStyle}>
                              {row?.restrictedflag === 1 || (row?.is_active === 1 && isActive) || isInActive ? (
                                <Tooltip
                                  title={row.restrictedflag === 1 ? 'Cannot unselect this ledger' : ''}
                                  disableHoverListener={row.restrictedflag !== 1}
                                >
                                  <Checkbox
                                    sx={{ padding: 0, m: 0 }}
                                    disabled={row.restrictedflag === 1}
                                    checked={BsSelectedRows.includes(row.accountid)}
                                    onChange={(e) => handleCheckboxChange(e, row, 'BS')}
                                  />
                                </Tooltip>
                              ) : row.restrictedflag === 0 && !isActive ? (
                                <Tooltip
                                  title={`This ledger is currently active but won't be transferred. Want to include it? Just tick the Active box under ${tooltipItem}.`}
                                >
                                  {' '}
                                  <CancelPresentation sx={{ color: 'red' }} />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title={`This ledger is currently inactive and won't be transferred.
           Want to include it? Just tick the Inactive box under ${tooltipItem}.`}
                                >
                                  <CancelPresentation sx={{ color: 'red' }} />
                                </Tooltip>
                              )}{' '}
                            </div>

                            {/* Account Name */}
                            <div style={colFlex(4)}>
                              <Typography
                                variant="body2"
                                sx={{
                                  ...cellStyle,
                                  color:
                                    row?.restrictedflag === 1
                                      ? 'green'
                                      : (isActive && row?.is_active === 1) || isInActive
                                      ? 'green'
                                      : 'red',
                                }}
                              >
                                {isDefaultRow ? row.immediate_parent_group_name : row.accountname}
                                {row?.restrictedflag === 1 && (
                                  <span
                                    style={{
                                      fontStyle: 'italic',
                                      fontSize: '12px',
                                      color: '#818694',
                                      marginLeft: '5px',
                                    }}
                                    className="hover-default"
                                  >
                                    default a/c
                                  </span>
                                )}
                              </Typography>
                            </div>

                            {/* Group */}
                            <div style={colFlex(4)}>
                              <Typography
                                variant="body2"
                                sx={{
                                  ...cellStyle,
                                  color:
                                    row?.restrictedflag === 1
                                      ? 'green'
                                      : (isActive && row?.is_active === 1) || isInActive
                                      ? 'green'
                                      : 'red',
                                }}
                              >
                                {isDefaultRow ? 'Reserves and Surplus' : row.immediate_parent_group_name}
                              </Typography>
                            </div>

                            {/* Balance */}
                            <div style={colFlex(2)}>
                              <Typography
                                variant="body2"
                                sx={{
                                  ...cellStyle,
                                  color:
                                    row?.restrictedflag === 1
                                      ? 'green'
                                      : (isActive && row?.is_active === 1) || isInActive
                                      ? 'green'
                                      : 'red',
                                  display: 'flex',
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {hasBalance ? (
                                  <>
                                    {MoneyFormatv3(displayBalance)} {balanceLabel}
                                  </>
                                ) : (
                                  '0.00'
                                )}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
              <Box
                sx={{
                  backgroundColor: theme.palette.secondary.main,
                  height: '40px',
                  display: 'flex',
                  alignItems: 'center',
                  paddingLeft: '16px',
                }}
              >
                <Typography variant="body2" sx={{ color: 'white' }}>
                  Profit and Loss Accounts
                </Typography>
              </Box>

              <div style={{ boxSizing: 'border-box', width: '100%' }}>
                {/* Header */}
                <div style={headerStyle}>
                  <div style={checkboxCellStyle}>
                    <Checkbox
                      color="primary"
                      indeterminate={PLSelectedRows.length > 0 && PLSelectedRows.length < profitNLoss.length}
                      checked={profitNLoss.length > 0 && PLSelectedRows.length === profitNLoss.length}
                      onChange={(e) => handleonSelectAllClick(e, 'pandl')}
                      inputProps={{
                        'aria-label': 'select all desserts',
                      }}
                    />
                  </div>
                  <div style={colFlex(4)}>
                    <Typography variant="body1" fontWeight="bold">
                      Accounts
                    </Typography>
                  </div>
                  <div style={colFlex(4)}>
                    <Typography variant="body1" fontWeight="bold">
                      Groups
                    </Typography>
                  </div>
                </div>

                {/* Virtualized Scrollable Content */}
                <div
                  ref={table2ref}
                  style={{
                    height: '400px',
                    overflowY: 'auto',
                    border: '1px solid #ccc',
                  }}
                >
                  <div
                    style={{
                      height: `${rowPandLVirtualizer.getTotalSize()}px`,
                      position: 'relative',
                    }}
                  >
                    {rowPandLVirtualizer.getVirtualItems().map((virtualRow) => {
                      const row = profitNLoss[virtualRow.index];
                      const isActive = createNewFyDta?.ledgerTransfer?.active === 1;

                      const isInActive = createNewFyDta?.ledgerTransfer?.inactive === 1;
                      return (
                        <div
                          key={virtualRow.key}
                          ref={virtualRow.measureRef}
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: `${virtualRow.size}px`,
                            borderBottom: '1px solid rgb(218, 217, 217)',
                            transform: `translateY(${virtualRow.start}px)`,
                          }}
                        >
                          <div style={rowContainerStyle}>
                            <div style={checkboxCellStyle}>
                              {row?.restrictedflag === 1 || (row?.is_active === 1 && isActive) || isInActive ? (
                                <Tooltip
                                  title={row.restrictedflag === 1 ? 'Cannot unselect this ledger' : ''}
                                  disableHoverListener={row.restrictedflag !== 1}
                                >
                                  <span>
                                    <Checkbox
                                      sx={{ padding: 0, m: 0 }}
                                      disabled={row?.restrictedflag === 1}
                                      checked={PLSelectedRows.includes(row.accountid)}
                                      onChange={(e) => {
                                        if (row.restrictedflag !== 1 || e.target.checked) {
                                          handleCheckboxChange(e, row, 'PL');
                                        }
                                      }}
                                    />
                                  </span>
                                </Tooltip>
                              ) : row.restrictedflag === 0 && !isActive ? (
                                <Tooltip
                                  title={`This ledger is currently active but won't be transferred. Want to include it? Just tick the Active box under 
                                    Ledgers.`}
                                >
                                  {' '}
                                  <CancelPresentation sx={{ color: 'red' }} />
                                </Tooltip>
                              ) : (
                                <Tooltip
                                  title="This ledger is currently inactive and won’t be transferred.
                                       Want to include it? Just tick the Inactive box under Ledgers."
                                >
                                  <CancelPresentation sx={{ color: 'red' }} />
                                </Tooltip>
                              )}
                            </div>

                            {/* Account Name */}
                            <div style={colFlex(4)}>
                              <Typography
                                variant="body2"
                                sx={{
                                  ...cellStyle,
                                  color:
                                    row?.restrictedflag === 1
                                      ? 'green'
                                      : (isActive && row?.is_active === 1) || isInActive
                                      ? 'green'
                                      : 'red',
                                }}
                              >
                                {row?.accountname}
                                {row?.restrictedflag === 1 && (
                                  <span
                                    style={{
                                      fontStyle: 'italic',
                                      fontSize: '12',
                                      color: '#818694',
                                      marginLeft: '5px',
                                    }}
                                    className="hover-default"
                                  >
                                    default a/c
                                  </span>
                                )}
                              </Typography>
                            </div>

                            {/* Group */}
                            <div style={colFlex(4)}>
                              <Typography
                                variant="body2"
                                sx={{
                                  ...cellStyle,
                                  color:
                                    row?.restrictedflag === 1
                                      ? 'green'
                                      : (isActive && row?.is_active === 1) || isInActive
                                      ? 'green'
                                      : 'red',
                                }}
                              >
                                {row?.immediate_parent_group_name}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </>
          )}
        </Box>
      </Box>
      <NewFyButtons />
    </>
  );
}

export default FYSterpThree;
